import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Properties for {@link GroupRedirect}
 */
type GroupRedirectProps = {};

/**
 * Redirect page for groups
 */
function GroupRedirect(props: GroupRedirectProps) {
    return <Navigate to={"/c/groups/local"} search={{ search: "", page: 1 }} />;
}

export const Route = createFileRoute("/_customer/c/groups/")({
    component: GroupRedirect,
});
